import React from "react";

const ContactMapSection: React.FC = () => {
    return (
        <section className="contact-map-section">
            <h2 className="hidden">Contact map</h2>
            <div className="contact-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2610.950661946929!2d18.327525877479758!3d49.125572181865536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47148f420ccd6dd9%3A0xc6fcb4df0a63ecd7!2sELEKTROWERK%2C%20s.%20r.%20o.!5e0!3m2!1sen!2scz!4v1723136495748!5m2!1sen!2scz" width="600" height="450" loading="lazy"></iframe>
            </div>
        </section>
    );
}

export default ContactMapSection;